import { SIDE_BAR } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  reportType :"",
  settingsMenuValue: "",
  contactsMenuValue: "",
  reportsMenuValue: "",
  forceCloseSideBarOverLayContacts: false,
  forceCloseSideBarOverLaySettings: false,
  forceCloseSideBarOverLayReports: false,
  sideBarOverlayContacts: false,
  sideBarOverlaySettings: false,
  sideBarOverlayReports: false,
  Menucollapse: false,
  mainValue: "",
  currentActivePanel: "reports",
};

const sidebarSlice = createSlice({
  name: SIDE_BAR,
  initialState,
  reducers: {
    reportType: (state,{payload}) => {
     
      state.reportType = payload.reportTypeValue
      switch(payload.reportTypeValue) {
        case '1':
          state.reportsMenuValue = "acr_report"
          break;
        case '2' :
          state.reportsMenuValue = "c_report"
          // break;
          // case '3' :
          //   state.reportsMenuValue = "acs_report"
      }
    },
    settingsMenu: (state, { payload }) => {
      state.settingsMenuValue = payload.settingsMenuValue;
    },
    reportsMenu: (state, { payload }) => {
      state.reportsMenuValue = payload.reportsMenuValue;
    },
    setCurrentActivePanel: (state, { payload }) => {
      state.currentActivePanel = payload.panel;
    },
    contactsMenu: (state, { payload }) => {
      state.contactsMenuValue = payload.contactsMenuValue;
    },
    sideBarOverlayCloseContacts: (state, { payload }) => {
      state.forceCloseSideBarOverLayContacts =
        payload.forceCloseSideBarOverLayContacts;
    },
    sideBarOverlayCloseSettings: (state, { payload }) => {
      state.forceCloseSideBarOverLaySettings =
        payload.forceCloseSideBarOverLaySettings;
    },
    sideBarOverlayCloseReports: (state, { payload }) => {
      state.forceCloseSideBarOverLayReports =
        payload.forceCloseSideBarOverLayReports;
    },
    sideBarOverlayContacts: (state, { payload }) => {
      state.sideBarOverlayContacts = payload.sideBarOverlayContacts;
    },
    sideBarOverlayReports: (state, { payload }) => {
      state.sideBarOverlayReports = payload.sideBarOverlayReports;
    },
    sideBarOverlaySettings: (state, { payload }) => {
      state.sideBarOverlaySettings = payload.sideBarOverlaySettings;
    },
    sideBarOverlayCollapse: (state, { payload }) => {
      state.Menucollapse = payload.Menucollapse;
    },
    leftMenuValues: (state, { payload }) => {
      state.mainValue = payload.mainValue;
    },
    reset: () => {},
  },
});
export const sidebarActions = sidebarSlice.actions;
export default sidebarSlice.reducer;
